<template>
    <div class="registerWraper">
        <div class="form form-3">
            <div class="group group-9">
                <svg xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink"
                     width="19px"
                     height="22px"
                     class="svg">
                    <path fill-rule="evenodd"
                          fill="rgb(187, 187, 187)"
                          d="M9.493,11.001 C12.498,11.001 14.938,8.538 14.938,5.500 C14.938,2.462 12.498,-0.000 9.493,-0.000 C6.486,-0.000 4.048,2.462 4.048,5.500 C4.048,8.538 6.484,11.001 9.493,11.001 ZM16.994,14.433 C15.750,12.997 15.329,12.503 13.052,12.371 L5.942,12.371 C3.662,12.506 3.244,12.997 2.003,14.433 C0.681,15.914 -0.372,17.796 0.126,20.124 C0.681,21.650 2.174,22.000 3.591,22.000 L15.407,22.000 C16.823,22.000 18.319,21.647 18.874,20.124 C19.367,17.796 18.316,15.916 16.994,14.433 Z" />
                </svg>
                <input type="text"
                       class="userName"
                       v-model="formRegister.passport"
                       placeholder="请输入用户名"
                       maxlength="32"
                       spellcheck="false"
                       @keyup.enter="fnVerifyRegister" />
            </div>
            <div class="group group-10">
                <svg xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink"
                     width="17px"
                     height="23px"
                     class="svg">
                    <path fill-rule="evenodd"
                          fill="rgb(187, 187, 187)"
                          d="M14.455,23.000 L2.545,23.000 C1.142,22.997 0.006,21.728 -0.000,20.159 L-0.000,11.167 C0.006,9.597 1.142,8.327 2.545,8.320 L2.905,8.320 L2.905,6.261 C2.906,2.803 5.412,0.000 8.504,0.001 C11.594,0.001 14.100,2.804 14.100,6.261 L14.100,8.320 L14.455,8.320 C15.858,8.327 16.994,9.597 17.000,11.167 L17.000,20.159 C16.994,21.728 15.857,22.997 14.455,23.000 ZM7.443,16.133 L7.443,19.090 L9.540,19.090 L9.540,16.140 L9.557,16.133 C9.884,15.924 10.155,15.620 10.343,15.254 C10.926,14.115 10.574,12.663 9.557,12.010 C8.539,11.357 7.241,11.751 6.657,12.890 C6.073,14.028 6.425,15.481 7.443,16.133 ZM12.462,6.261 C12.462,3.815 10.689,1.833 8.502,1.833 C6.316,1.833 4.544,3.816 4.543,6.261 L4.543,8.320 L12.462,8.320 L12.462,6.261 Z" />
                </svg>
                <input type="password"
                       class="userPwd"
                       v-model="formRegister.password"
                       placeholder="请输入密码"
                       maxlength="16"
                       @focus="fnInputFocus"
                       @keyup.enter="fnVerifyRegister" />
            </div>
            <div class="group group-11">
                <svg xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink"
                     width="17px"
                     height="23px"
                     class="svg">
                    <path fill-rule="evenodd"
                          fill="rgb(187, 187, 187)"
                          d="M14.455,23.000 L2.545,23.000 C1.142,22.997 0.006,21.728 -0.000,20.159 L-0.000,11.167 C0.006,9.597 1.142,8.327 2.545,8.320 L2.905,8.320 L2.905,6.261 C2.906,2.803 5.412,0.000 8.504,0.001 C11.594,0.001 14.100,2.804 14.100,6.261 L14.100,8.320 L14.455,8.320 C15.858,8.327 16.994,9.597 17.000,11.167 L17.000,20.159 C16.994,21.728 15.857,22.997 14.455,23.000 ZM7.443,16.133 L7.443,19.090 L9.540,19.090 L9.540,16.140 L9.557,16.133 C9.884,15.924 10.155,15.620 10.343,15.254 C10.926,14.115 10.574,12.663 9.557,12.010 C8.539,11.357 7.241,11.751 6.657,12.890 C6.073,14.028 6.425,15.481 7.443,16.133 ZM12.462,6.261 C12.462,3.815 10.689,1.833 8.502,1.833 C6.316,1.833 4.544,3.816 4.543,6.261 L4.543,8.320 L12.462,8.320 L12.462,6.261 Z" />
                </svg>
                <input type="password"
                       class="userPwd"
                       v-model="formRegister.repassword"
                       placeholder="请再次输入密码"
                       maxlength="16"
                       @keyup.enter="fnVerifyRegister" />
            </div>
            <div class="group errMsg"
                 v-text="formRegister.errMsg"></div>
            <div class="group group-13">
                <a href="javascript:;"
                   class="btnNml btnSubmit"
                   @click="fnVerifyRegister"
                   v-text="btnSubmitTxt"></a>
            </div>
            <div class="group group-12">
                <input type="checkbox"
                       v-model="checkAgree"
                       class="checkAgreement" />
                <div class="agreementWraper">
                    <div v-if="!checkAgree">
                        <svg xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                             width="17px"
                             height="17px">
                            <path fill-rule="evenodd"
                                  stroke="rgb(187, 187, 187)"
                                  stroke-width="1px"
                                  stroke-linecap="butt"
                                  stroke-linejoin="miter"
                                  fill="rgb(255, 255, 255)"
                                  d="M0.500,0.500 L16.500,0.500 L16.500,16.500 L0.500,16.500 L0.500,0.500 Z" />
                        </svg>
                    </div>
                    <div v-else>
                        <svg xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink"
                             width="17px"
                             height="17px">
                            <path fill-rule="evenodd"
                                  stroke="rgb(187, 187, 187)"
                                  stroke-width="1px"
                                  stroke-linecap="butt"
                                  stroke-linejoin="miter"
                                  fill="rgb(255, 255, 255)"
                                  d="M0.500,0.500 L16.500,0.500 L16.500,16.500 L0.500,16.500 L0.500,0.500 Z" />
                            <path fill-rule="evenodd"
                                  fill="rgb(252, 157, 39)"
                                  d="M14.493,6.005 L7.838,13.492 L7.524,13.138 L7.165,13.496 L3.503,9.834 L4.834,8.503 L7.363,11.031 L13.162,4.507 L14.493,6.005 Z" />
                        </svg>
                    </div>
                    <div>&nbsp;&nbsp;我已经阅读并同意</div>
                </div>
                <a href="https://register.stnts.com/new/v2/protocol/get.do?name=agreement"
                   target="_blank"
                   class="colorfd9d2b">《盛天用户注册协议》</a>
            </div>
            <div class="group group-14">
                已经账号？
                <a href="javascript:;"
                   class="colorfd9d2b"
                   @click="fnSwitchLoger('normal')">返回登录&gt;&gt;</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'register',
    data () {
        return {
            formRegister: {
                passport: '',
                password: '',
                repassword: '',
                errMsg: ''
            },
            btnSubmitTxt: '注册账号',
            checkAgree: true,
            captchaObj: null
        }
    },
    mounted () {
        let t = this
        t.captchaObj && t.captchaObj.reset()
        t.fnGeeInit(function (geeData) {
            t.fnDoRegister(geeData)
        })
    },
    methods: {
        // 注册
        fnVerifyRegister () {
            if (!this.fnRegCheck()) return
            this.captchaObj.verify()
        },
        // 提交注册
        fnDoRegister (d) {
            let t = this
            if (!t.fnRegCheck()) return
            let geeData = d || {}
            geeData.passport = t.formRegister.passport
            geeData.password = t.formRegister.password
            geeData.source_page = ELSDK.SourcePage.box || 'yilewan_pcbox'
            geeData.game_code = t.$cookies.get('jsGameCode') || ''
            geeData.attr = t.$cookies.get('jsGameCode') ? 'game' : ''
            geeData.attr_value = t.$cookies.get('jsGameCode') ? t.$cookies.get('jsGameCode') : ''
            // eslint-disable-next-line
            ELSDK.SDKAPI('register', geeData, res => {
                if (res.status === 'error') {
                    t.formRegister.errMsg = res.msg
                    return
                }
                this.$emit('fnGetYilewanToken', 1)
            })
        },
        // 极验初始化
        fnGeeInit (fn) {
            var t = this
            // eslint-disable-next-line
            ELSDK.SDKAPI('geeInit', {}, (captchaObj) => {
                // debugger
                t.captchaObj = captchaObj
                t.captchaObj.onSuccess(function () {
                    var result = t.captchaObj.getValidate()
                    if (!result) {
                    } else {
                        var geeData = {
                            gee_client_type: 'web',
                            gee_challenge: result.geetest_challenge,
                            gee_validate: result.geetest_validate,
                            gee_seccode: result.geetest_seccode
                        }
                        fn && fn(geeData)
                    }
                })
            })
        },
        fnRegCheck () {
            let t = this
            if (!t.formRegister.passport) {
                t.formRegister.errMsg = '帐号不能为空'
                return false
            }
            if (t.formRegister.passport.length < 4) {
                t.formRegister.errMsg = '帐号长度为4-20'
                return false
            }
            if (!t.formRegister.password) {
                t.formRegister.errMsg = '密码不能为空'
                return false
            }
            if (t.formRegister.password.length < 4) {
                t.formRegister.errMsg = '密码长度为6-16位'
                return false
            }
            if (!t.formRegister.repassword) {
                t.formRegister.errMsg = '确认密码不能为空'
                return false
            }
            if (t.formRegister.repassword.length < 4) {
                t.formRegister.errMsg = '确认密码长度为6-16位'
                return false
            }
            if (t.formRegister.password !== t.formRegister.repassword) {
                t.formRegister.errMsg = '两次输入的密码不一致'
                return false
            }
            if (!t.checkAgree) {
                t.formRegister.errMsg = '请先阅读并同意《盛天用户注册协议》'
                return false
            }
            return true
        },
        fnSwitchLoger (type) {
            this.$emit('fnBtnClick', type)
        },
        // 获取焦点
        fnInputFocus () {
            this.formRegister.errMsg = ''
        },
    }
}
</script>
